// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {
    if (typeof tns === 'undefined') return;
    
    const container = document.querySelector('.sleep-position-guide__slider');
    if (!container) return;
  
    // Check if slider has slides
    const slides = container.querySelectorAll('.sleep-position-guide__slide');
    if (!slides.length) {
      return;
    }
  
    let sleepSlider = null;
    let intersectionObserver = null;
    let resizeRequestId = null;
    let heightObserver = null;
    const section = container.closest('.sleep-position-guide');
  
    // Function to equalize heights of all slides
    function equalizeSlideHeights() {
      requestAnimationFrame(function () {
        // Try to get .tns-item elements first (created by tiny slider)
        let items = container.querySelectorAll('.tns-item');
        
        // Fallback to original slides if .tns-item doesn't exist yet
        if (!items.length) {
          items = container.querySelectorAll('.sleep-position-guide__slide');
        }
        
        if (!items.length) return;
  
        // Reset heights to auto to get natural height
        items.forEach(function (item) {
          item.style.height = 'auto';
        });
  
        requestAnimationFrame(function () {
          let maxHeight = 0;
          items.forEach(function (item) {
            const h = item.offsetHeight;
            if (h > maxHeight) maxHeight = h;
          });
  
          if (maxHeight > 0) {
            items.forEach(function (item) {
              item.style.height = maxHeight + 'px';
            });
          }
        });
      });
    }
  
    function initSleepSlider() {
      // Destroy existing slider if it exists
      if (sleepSlider) {
        sleepSlider.destroy();
        sleepSlider = null;
      }
      
      // Disconnect height observer if it exists
      if (heightObserver) {
        heightObserver.disconnect();
        heightObserver = null;
      }
  
      const sliderConfig = {
        container: container,
        loop: true,
        gutter: 20,
        // Base config for mobile (< 600px): 1 slide with center
        items: 1,
        center: true,
        edgePadding: 90, // Equivalent to centerPadding: '90px' in Tiny Slider
        controls: false,
        nav: false,
        mouseDrag: true,
        touch: true,
        speed: 500,
        slideBy: 1,
        responsive: {
          // Tiny Slider uses min-width breakpoints (mobile-first)
          // Tiny Slider breakpoints: 600 (max-width) = 2 slides, 1024 (max-width) = 2 slides, base = 3 slides
          // Tiny Slider: < 600 = 1 slide, 600-1023 = 2 slides, >= 1024 = 3 slides
          767: {
            items: 2,
            center: false,
            edgePadding: 0,
            loop: true,
            slideBy: 1,
          },
          1024: {
            items: 3,
            center: false,
            edgePadding: 0,
            loop: true,
            slideBy: 1,
          },
        },
      };
  
      try {
        sleepSlider = tns(sliderConfig);
        
        // Set up MutationObserver to watch for .tns-item elements
        if (heightObserver) {
          heightObserver.disconnect();
        }
        
        heightObserver = new MutationObserver(function(mutations) {
          let hasNewItems = false;
          mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                if (node.classList && node.classList.contains('tns-item')) {
                  hasNewItems = true;
                } else if (node.querySelector && node.querySelector('.tns-item')) {
                  hasNewItems = true;
                }
              }
            });
          });
          
          if (hasNewItems) {
            equalizeSlideHeights();
          }
        });
        
        // Observe the container for new child elements
        heightObserver.observe(container, {
          childList: true,
          subtree: true
        });
        
        // Equalize heights immediately using requestAnimationFrame
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            equalizeSlideHeights();
          });
        });
        
        // Equalize heights when slider is ready
        if (sleepSlider && sleepSlider.events) {
          sleepSlider.events.on('indexChanged', function() {
            equalizeSlideHeights();
          });
        }
      } catch (error) {
        // Error initializing slider
      }
    }
  
    // Use IntersectionObserver to initialize slider when it enters viewport
    if (section && 'IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Section is in viewport, initialize slider
            if (!sleepSlider) {
              initSleepSlider();
            }
            
            // Disconnect observer after first initialization
            if (intersectionObserver) {
              intersectionObserver.disconnect();
              intersectionObserver = null;
            }
          }
        });
      }, {
        rootMargin: '50px' // Start loading slightly before element enters viewport
      });
      
      intersectionObserver.observe(section);
    } else {
      // Fallback: initialize immediately if IntersectionObserver not supported
      initSleepSlider();
    }
  
    // Resize handler using requestAnimationFrame
    function handleResize() {
      if (resizeRequestId) {
        cancelAnimationFrame(resizeRequestId);
      }
      
      resizeRequestId = requestAnimationFrame(function() {
        initSleepSlider();
        // Re-equalize heights after resize using requestAnimationFrame
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            equalizeSlideHeights();
          });
        });
      });
    }
  
    // Re-initialize on resize
    window.addEventListener('resize', handleResize);
  });
  
  